// this gets updated automatically
export const version = '3.2.0';
